export default __webpack_public_path__ + "static/media/091.0908e6a7.jpg";